module.exports = __webpack_public_path__ + "img/arrow-right-blue.894bb6a8.svg";